var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.6 21.9h8.8m-3.85-8.25h-11m11 0V9.8m0 3.85h9.9m-9.9-12.1v4.4m0 0V9.8m0-3.85h8.25M12.55 9.8h9.9M8.7 5.842h.55m0 0h.55m-.55 0v.497m0-.497v-.558m-4.312.558h.55m0 0h.55m-.55 0v.497m0-.497v-.558M8.7 10.017h.55m0 0h.55m-.55 0v.496m0-.496v-.559m-4.312.559h.55m0 0h.55m-.55 0v.496m0-.496v-.559M21.35 17.5H2.69M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.6418d30b6586354b2650cb440d9aceb3.svg";
export { ForwardRef as ReactComponent };